import { useTranslation } from 'react-i18next'

export default function CTASection() {
  const { t } = useTranslation('common')

  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20floating%20shapes%20in%20orange%20coral%20and%20peach%20tones%2C%20dreamy%20ethereal%20atmosphere%2C%20minimal%20modern%20design%2C%20smooth%20flowing%20waves%20of%20color%2C%20artistic%20digital%20composition%2C%20clean%20and%20inspiring%20mood&width=1800&height=600&seq=home-cta-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-500/85 to-accent-500/85"></div>

      <div className="relative z-10 text-center px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="font-heading text-2xl md:text-4xl text-background-50 mb-4">
          {t('home.ctaTitle')}
        </h2>
        <p className="text-background-200/90 text-sm md:text-lg mb-8 md:mb-10">
          {t('home.ctaSubtitle')}
        </p>
        <button className="px-8 md:px-10 py-3.5 md:py-4 rounded-full bg-background-50 text-primary-600 text-sm md:text-base font-semibold hover:bg-background-100 transition-all duration-300 shadow-lg cursor-pointer whitespace-nowrap">
          <i className="ri-download-cloud-2-line mr-2"></i>
          {t('home.ctaButton')}
        </button>
      </div>
    </section>
  )
}